import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'
import theme from 'ui/styles/theme'
import LocalizedString from 'ui/components/generic/LocalizedString'

export default class LanguageSelector extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    languages: PropTypes.array,
    defaultLanguage: PropTypes.string,
  }

  static defaultProps = {
    visible: false,
    languages: [],
    defaultLanguage: 'en'
  }
  
  render() {
    const { visible, languages, defaultLanguage } = this.props

    return (
      <Wrapper visible={visible}>
        <Content>
          <Container fluid>
            <Row>
              <Col sm={6} smOffset={3}>
                <h4><LocalizedString group="genericLabels" string="chooseLanguage" /></h4>
              </Col>
            </Row>
            {languages.map(language => (
              <Row key={language.key}>
                <Col sm={6} smOffset={3}>
                  <Language
                    href={`/${language.key === defaultLanguage ? '' : language.key}`}
                    >
                    <span>{language.title}</span>
                    {language.flag_icon && (
                      <Flag image={language.flag_icon} />
                    )}
                  </Language>
                </Col>
              </Row>
            ))}
          </Container>
        </Content>
      </Wrapper>
    )
  }
}

// Styles
const { colors, navHeight } = theme

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
  z-index: 19;
  overscroll-behavior: contain;
  opacity: ${props => props.visible ? 1 : 0};
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
  transition: opacity 0.2s ${easing.easeOutCubic};
  padding-top: ${navHeight}px;
  display: flex;
  align-items: center;

  h4 {
    text-align: center;
  }
`

const Content = styled.div`
  padding-bottom: 4rem;
  max-height: 100%;
  overflow: auto;
  position: relative;
  width: 100%;
`

const Language = styled.a`
  display: flex;
  align-items: center;
  background: #f0f0f0;
  margin-bottom: 2px;
  padding: 0.75rem;
  border-radius: 0.5rem;
  text-transform: uppercase;
  font-size: 0.75rem;
  color: black;
  transition: background-color 0.3s ${easing.easeOutCubic}, color 0.3s ${easing.easeOutCubic};

  &:hover {
    background-color: ${colors.primary};
    color: white;
  }

  span {
    flex-grow: 1;
  }
`

const Flag = styled.div`
  background-image: url(${props => props.image});
  background-position: center;
  background-size: cover;
  width: 25px;
  height: 25px;
  border-radius: 100%;
`


// WEBPACK FOOTER //
// ./src/ui/components/Navigation/LanguageSelector/index.js